(() => {
  const modal = document.querySelector('[data-lbc-size-guide-modal]');
  if (modal) {
    const dialog = modal.querySelector('.lbc-size-guide-modal__dialog');
    let lastFocused = null;
    const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const open = () => {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(() => dialog?.focus(), 0);
    };
    const close = () => {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      lastFocused?.focus?.();
    };
    document.querySelectorAll('[data-lbc-size-guide-open]').forEach((button) => button.addEventListener('click', open));
    modal.querySelectorAll('[data-lbc-size-guide-close]').forEach((button) => button.addEventListener('click', close));
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab' || modal.hidden || !dialog) return;
      const focusable = [...dialog.querySelectorAll(focusableSelector)].filter((element) => !element.disabled && element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  const sticky = document.querySelector('[data-lbc-mobile-sticky-atc]');
  const stickyButton = sticky?.querySelector('.lbc-mobile-sticky-atc__button');
  const stickyPrice = sticky?.querySelector('.lbc-mobile-sticky-atc__text strong');
  const mainButton = document.querySelector('.product-form__buttons .product-form__submit');
  const mainPrice = document.querySelector('.product__info-container .price-item--sale') || document.querySelector('.product__info-container .price-item--regular');

  const syncSticky = () => {
    if (mainButton && stickyButton) {
      stickyButton.disabled = mainButton.disabled;
      const label = mainButton.querySelector('span')?.textContent?.trim();
      if (label) stickyButton.textContent = label;
    }
    const currentPrice = document.querySelector('.product__info-container .price-item--sale') || document.querySelector('.product__info-container .price-item--regular');
    if (currentPrice && stickyPrice) stickyPrice.textContent = currentPrice.textContent.trim();
  };

  const variantPicker = document.querySelector('variant-selects, variant-radios');
  const sizeFieldset = variantPicker
    ? [...variantPicker.querySelectorAll('fieldset')].find((fieldset) => /size/i.test(fieldset.querySelector('legend')?.textContent || ''))
    : null;
  const sizeInputs = sizeFieldset ? [...sizeFieldset.querySelectorAll('input[type="radio"]')] : [];
  const productForm = mainButton?.closest('form');

  if (sizeInputs.length > 1 && !new URLSearchParams(window.location.search).has('variant') && mainButton && productForm) {
    sizeInputs.forEach((input) => { input.checked = false; });
    productForm.classList.add('lbc-size-selection-required');
    mainButton.disabled = true;
    const label = mainButton.querySelector('span');
    if (label) label.textContent = 'Select a size';
    if (stickyButton) {
      stickyButton.disabled = true;
      stickyButton.textContent = 'Select a size';
    }
    sizeInputs.forEach((input) => input.addEventListener('change', () => {
      productForm.classList.remove('lbc-size-selection-required');
      window.setTimeout(syncSticky, 180);
    }));
  }

  document.querySelectorAll('variant-selects input, variant-selects select, variant-radios input').forEach((control) => {
    control.addEventListener('change', () => window.setTimeout(syncSticky, 180));
  });
  if (mainButton) new MutationObserver(syncSticky).observe(mainButton, { attributes: true, childList: true, subtree: true });
  if (mainPrice) new MutationObserver(syncSticky).observe(mainPrice.closest('.price') || mainPrice, { childList: true, subtree: true });

  if (sticky) {
    document.body.classList.add('lbc-has-mobile-sticky-atc');
    sticky.classList.add('is-hidden');
    const buyArea = document.querySelector('.product-form__buttons');
    if (buyArea && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const isBelowViewport = entry.boundingClientRect.top > 0;
        sticky.classList.toggle('is-hidden', entry.isIntersecting || isBelowViewport);
      }, { threshold: .15 }).observe(buyArea);
    }
  }
  syncSticky();
})();